module.exports = __webpack_public_path__ + "img/communication.c4b02198.svg";